import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

import translations from './pages/Invoices.translations'

const routes = (): RouteRecordRaw[] => {
  return [
    {
      component: () => import('~/scopes/invoices/pages/Invoices.vue'),
      redirect: { name: ROUTE_NAMES.INVOICES.WALLET },
      name: ROUTE_NAMES.INVOICES.INDEX,
      path: '/bo-seller/invoices',
      meta: {
        autonomousBannerPageName: 'invoices',
        owners: ['bot-squad-seller-experience-front'],
      },
      children: [
        {
          component: () =>
            import('~/scopes/invoices/pages/tabs/wallet/Wallet.vue'),
          name: ROUTE_NAMES.INVOICES.WALLET,
          path: 'wallet',
          meta: {
            autonomousBannerPageName: 'invoices.wallet',
            tabItem: {
              label: translations.invoicesWalletTab,
              loadingText: translations.invoicesWalletTabLoading,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () =>
            import('~/scopes/invoices/pages/tabs/past-invoices/PastInvoices.vue'),
          name: ROUTE_NAMES.INVOICES.PAST_INVOICES.INDEX,
          path: 'past-invoices',
          redirect: { name: ROUTE_NAMES.INVOICES.PAST_INVOICES.SALES },
          meta: {
            autonomousBannerPageName: 'invoices.past-invoices',
            tabItem: {
              label: translations.invoicesInvoicesTab,
              loadingText: translations.invoicesInvoicesTabLoading,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
          children: [
            {
              component: () =>
                import('~/scopes/invoices/pages/tabs/past-invoices/tabs/Sales/Sales.vue'),
              name: ROUTE_NAMES.INVOICES.PAST_INVOICES.SALES,
              path: 'sales',
              meta: {
                tabItem: {
                  label: translations.salesTab,
                  loadingText: translations.tabLoading,
                },
                owners: ['bot-squad-seller-experience-front'],
              },
            },
            {
              component: () =>
                import('~/scopes/invoices/pages/tabs/past-invoices/tabs/TradeIn/TradeIn.vue'),
              name: ROUTE_NAMES.INVOICES.PAST_INVOICES.TRADE_IN,
              path: 'trade-in',
              meta: {
                tabItem: {
                  label: translations.tradeInTab,
                  loadingText: translations.tabLoading,
                },
                owners: ['bot-squad-seller-experience-front'],
              },
            },
          ],
        },
        {
          component: () =>
            import('~/scopes/invoices/pages/tabs/goodwill-gestures/GoodwillGestures.vue'),
          name: ROUTE_NAMES.INVOICES.GOODWILL_GESTURES,
          path: 'goodwill-gestures',
          meta: {
            autonomousBannerPageName: 'invoices.goodwill-gestures',
            tabItem: {
              label: translations.invoicesCommercialGestureTab,
              loadingText: translations.invoicesCommercialGestureTabLoading,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () =>
            import('~/scopes/invoices/pages/tabs/seller-compensation/SellerCompensation.vue'),
          name: ROUTE_NAMES.INVOICES.SELLER_COMPENSATION,
          path: 'seller-compensation',
          meta: {
            autonomousBannerPageName: 'invoices.seller-compensation',
            tabItem: {
              label: translations.invoicesCompensationTab,
              loadingText: translations.invoicesCompensationTabLoading,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          component: () =>
            import('~/scopes/invoices/pages/tabs/financial-report/FinancialReport.vue'),
          name: ROUTE_NAMES.INVOICES.FINANCIAL_REPORT,
          path: 'financial-report',
          meta: {
            autonomousBannerPageName: 'invoices.financial-report',
            businessFeatures: ['financeReportEnabled'],
            tabItem: {
              label: translations.FinancialReportTab,
              loadingText: translations.FinancialReportTabLoading,
            },
            owners: ['bot-squad-seller-experience-front'],
          },
        },
      ],
    },
  ]
}

export default routes
